module.exports = __webpack_public_path__ + "static/media/sn_h_tt.5135fed6.svg";